var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Route, Redirect, Switch } from 'react-router-dom';
import cxs from 'cxs/component';
import Theme, { marks, mediaQueries, strMark } from 'Theme';
import DashboardTicket from 'modules/DashboardTicket';
import Users from 'modules/Users';
import ReportsRoutes from 'modules/Reports';
import Taxes from 'modules/Taxes';
import { TitleBar, } from 'components';
import { Button, Scroll } from 'elements';
import BusinessUnits from 'modules/BusinessUnits';
import OperationLines from 'modules/OperationLines';
import PassengerCategories from 'modules/PassengerCategories';
import StretchesRoutes from 'modules/Stretches';
import Devices from '../modules/Devices';
import Help from '../modules/Help';
import Voucher from '../modules/Vouchers';
import PacketsRoutes from 'modules/Packets';
import SchedulesRoutes from 'modules/Schedules';
import CollaboratorsRoutes from 'modules/Collaborators';
import ArticlessRoutes from 'modules/Articles';
import FamiliesRoutes from 'modules/Families';
import { Col, Container, Row } from 'reactstrap';
import history from '../helpers/History';
import Acount from '../modules/Acount';
import AfiliateRoutes from '../modules/Afiliates';
import DiscountReasonRoutes from '../modules/DiscountReasons';
import SettingCashMovementRoutes from '../modules/SettingCashMovements';
import AddressRoutes from '../modules/Headboards';
import CollaboratorStretchesRoutes from '../modules/CollaboratorStretches';
import { T } from '../helpers/i18n';
import UsedGaugesRoutes from '../modules/UsedGauges';
import ExtrasRoutes from '../modules/Extras';
import OtasRoutes from '../modules/Otas';
import CollaboratorPacketsRoutes from '../modules/CollaboratorPackets';
import MoneysRoutes from '../modules/Moneys';
import DiscountCodesIndex from '../modules/DiscountCodes/DiscountCodesIndex';
import theme from 'Theme';
import Destinations from '../modules/Destinations';
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Main.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var isDesktop = this.props.store.UI.isDesktop;
        var menuSelected = this.props.store.UI.menuSelected;
        var menuName = menuSelected || this.props.location.pathname.split('/');
        // console.log('this.props.location: ', this.props.location)
        // console.log('menuName: ', menuName)
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        var routes = [].concat.apply([], sections(this.props.store.users.user, isCivitrip).map(function (section) { return section.links; }));
        var path = {
            parent: undefined,
            name: T(menuName[1] || ''),
            action: ''
        };
        if (menuName[2]) {
            if (menuName[2] === 'create') {
                path.action = T(menuName[2]);
            }
            else {
                var link = routes.find(function (value) {
                    return value.name === menuName[1];
                });
                if (link && link.action) {
                    path.action = T(link.action);
                }
                else {
                    path.action = T('edit');
                }
            }
        }
        var clientName = (_g = (_d = (_c = (_b = this.props.store.users) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.tradename) !== null && _d !== void 0 ? _d : (_f = (_e = this.props.store.users) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.client) !== null && _g !== void 0 ? _g : '';
        return (React.createElement(Wrapper, null,
            React.createElement(TitleBar, null),
            React.createElement("div", { className: "navbar", style: {
                    border: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
                    borderTopWidth: 0,
                    borderLeftWidth: 0,
                    borderRightWidth: 0,
                } },
                React.createElement("div", null, "".concat(path.parent ? path.parent + ' | ' : '', " ").concat(path.name ? path.name : '', " ").concat(path.action ? ' | ' + path.action : '')),
                React.createElement("div", null, clientName)),
            React.createElement(Content, null,
                React.createElement(Scroll, null,
                    React.createElement(Switch, null,
                        React.createElement(Route, { exact: true, path: "/", render: function (props) {
                                return React.createElement(Redirect
                                // @ts-ignore
                                , __assign({ 
                                    // @ts-ignore
                                    queryParams: _this.props.queryParams, to: "calendar" }, props));
                            } }),
                        routes.map(function (route, index) {
                            return (React.createElement(Route, { key: index, path: route.path, render: function (props) { return React.createElement(route.component, __assign({}, props, { queryParams: _this.props.queryParams })); } }));
                        }),
                        React.createElement(Route, { render: function () {
                                return React.createElement(Container, { className: "mt-5" },
                                    React.createElement(Row, { className: "justify-content-center mt-5" },
                                        React.createElement(Col, { xl: 4, lg: 5 },
                                            React.createElement("div", { className: "text-center" },
                                                React.createElement("div", null,
                                                    React.createElement("h1", { style: { fontSize: 60 } }, " 404 "))))),
                                    React.createElement(Row, null,
                                        React.createElement(Col, { className: "text-center" },
                                            React.createElement("p", { className: "mb-5", style: { fontSize: 30, textTransform: 'none' } }, "Esta p\u00E1gina no fue encontrada."),
                                            React.createElement("p", { className: "mb-5", style: { fontSize: 20, textTransform: 'none' } }, "Es posible que haya escrito mal la direcci\u00F3n o que la p\u00E1gina se haya movido."),
                                            React.createElement(Button, { primary: true, onClick: function () { history.goBack(); }, className: "btn-lg  mt-4" }, "Atr\u00E1s"))));
                            } }))))));
    };
    Main = __decorate([
        inject('store'),
        observer
    ], Main);
    return Main;
}(Component));
export default Main;
var Wrapper = cxs('div')((_a = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    _a[mediaQueries.desktop] = {
        height: '95%'
    },
    /*[mediaQueries.desktop]: {*/
    _a.maxHeight = '100%',
    _a.margin = "0 auto auto auto",
    // borderColor: Theme.color.hairline,
    // borderWidth: `0 ${Theme.size.hairline}`,
    _a.border = "1px solid ".concat(theme.color.hairline),
    // borderStyle: 'solid',
    /*maxWidth: Theme.common.size.maxWidth + 'px',*/
    _a.width = '100%',
    /*paddingRight: '15px',
    paddingLeft: '15px',*/
    /*marginRight: 'auto',*/
    /*marginLeft: 'auto',*/
    /*'@media (min-width: 576px)': {
      maxWidth: '576px'
    },*/
    _a['@media (min-width: 720px)'] = {
        maxWidth: '720px'
    },
    _a['@media (min-width: 992px)'] = {
        maxWidth: '992px'
    },
    _a['@media (min-width: 1200px)'] = {
        maxWidth: '1140px'
    },
    _a['@media (min-width: 1500px)'] = {
        maxWidth: '1440px'
    },
    _a['@media (min-width: 1800px)'] = {
        maxWidth: '1740px'
    },
    _a['@media (min-width: 2100px)'] = {
        maxWidth: '2040px'
    }
/*} as CSSProperties*/
,
    _a));
var Content = cxs('div')({
    flex: 1,
    display: 'flex',
    position: 'relative',
    /*[mediaQueries.desktop]: {*/
    /*flex: 'auto',*/
    minHeight: '100px'
    /*} as CSSProperties*/
});
export var sectionsNavBar = function () {
    return [
    /*{
      name: 'configuracion',
      redirect: '/users'
    },
    {
      name: 'operaciones',
      redirect: '/customers'
    },
    {
      name: 'reportes',
      redirect: '/sales'
    }*/
    ];
};
var ticandoHelpSections = {
    name: 'help',
    links: [
        {
            name: '0-introduccion',
            path: '/help/0-introduccion',
            component: Help,
        },
        {
            name: '1-crearnegocio',
            path: '/help/1-crearnegocio',
            component: Help,
        },
        {
            name: '2-crearUsuario',
            path: '/help/2-crearUsuario',
            component: Help,
        },
        {
            name: '3-modificarUsuario',
            path: '/help/3-modificarUsuario',
            component: Help,
        },
        {
            name: '4-crearCategoriaPasajero',
            path: '/help/4-crearCategoriaPasajero',
            component: Help,
        },
        {
            name: '5-Linea de operacion',
            path: '/help/5-LineaOperacion',
            component: Help,
        },
        {
            name: '6-servicio ida y vuelta',
            path: '/help/6-servicioIdaVuelta',
            component: Help,
        },
        {
            name: '7-ServicioHopONHopoff',
            path: '/help/7-ServicioHopONHopoff',
            component: Help,
        },
        {
            name: '8-crearHorarios',
            path: '/help/8-crearHorarios',
            component: Help,
        },
        {
            name: '9-servicioConHorario',
            path: '/help/9-servicioConHorario',
            component: Help,
        },
        {
            name: '10-listadoTickets',
            path: '/help/10-listadoTickets',
            component: Help,
        },
        {
            name: '11-crearPaquete',
            path: '/help/11-crearPaquete',
            component: Help,
        },
        {
            name: '12-familiasArticulos',
            path: '/help/12-familiasArticulos',
            component: Help,
        },
    ]
};
var civitripHelpSections = {
    name: 'help',
    links: [
        {
            name: '1-introduccion',
            path: '/help/1-introduccion',
            component: Help,
        },
        {
            name: '2-negocios',
            path: '/help/2-negocios',
            component: Help,
        },
        {
            name: '3-usuarios',
            path: '/help/3-usuarios',
            component: Help,
        },
        {
            name: '4-categoriasPasajeroHorarios',
            path: '/help/4-categoriasPasajeroHorarios',
            component: Help,
        },
        {
            name: '5-impuestoExtrasMonedas',
            path: '/help/5-impuestoExtrasMonedas',
            component: Help,
        },
        {
            name: '6-lineaOperacion',
            path: '/help/6-lineaOperacion',
            component: Help,
        },
        {
            name: '7-servicios',
            path: '/help/7-servicios',
            component: Help,
        },
        {
            name: 'tutorialCivitrip',
            path: '/help/tutorialCivitrip',
            component: Help
        },
    ]
};
var helpSections = function (isCivitrip) {
    if (isCivitrip) {
        return civitripHelpSections;
    }
    return ticandoHelpSections;
};
export var sections = function (user, isCivitrip) {
    return [
        {
            name: 'wharehouse',
            links: [
                {
                    name: 'operationlines',
                    path: '/operationlines',
                    component: OperationLines
                },
                {
                    name: 'stretches',
                    path: '/stretches',
                    component: StretchesRoutes
                },
                {
                    name: 'packets',
                    path: '/packets',
                    component: PacketsRoutes
                },
                /*{
                  name: 'packetarticles',
                  path: '/packetarticles',
                  component: PacketArticlesRoutes
                },*/
                {
                    name: 'articles',
                    path: '/articles',
                    component: ArticlessRoutes
                },
                {
                    name: 'collaboratorstretches',
                    path: '/collaboratortretches',
                    component: CollaboratorStretchesRoutes,
                    action: 'info'
                },
                {
                    name: 'collaboratorspackets',
                    path: '/collaboratorpackets',
                    component: CollaboratorPacketsRoutes,
                    action: 'info'
                },
            ]
        },
        {
            name: user.isAdministrator || user.isSupport ? 'settings' : '',
            links: [
                {
                    name: 'myAccount',
                    path: '/acount',
                    component: Acount
                },
                {
                    name: 'businessunits',
                    path: '/businessunits',
                    component: BusinessUnits
                },
                {
                    name: 'users',
                    path: '/users',
                    component: Users
                },
                {
                    name: 'passengercategories',
                    path: '/passengercategories',
                    component: PassengerCategories
                },
                {
                    name: 'devices',
                    path: '/devices',
                    component: Devices
                },
                {
                    name: 'schedules',
                    path: '/schedules',
                    component: SchedulesRoutes
                },
                {
                    name: 'collaborators',
                    path: '/collaborators',
                    component: CollaboratorsRoutes
                },
                {
                    name: 'otas',
                    path: '/otas',
                    component: OtasRoutes
                },
                {
                    name: 'afiliates',
                    path: '/afiliates',
                    component: AfiliateRoutes
                },
                {
                    name: 'discountreasons',
                    path: '/discountreasons',
                    component: DiscountReasonRoutes
                },
                {
                    name: 'families',
                    path: '/families',
                    component: FamiliesRoutes
                },
                {
                    name: 'extras',
                    path: '/extras',
                    component: ExtrasRoutes
                },
                {
                    name: 'moneys',
                    path: '/moneys',
                    component: MoneysRoutes
                },
                {
                    name: 'settingcashmovements',
                    path: '/settingcashmovements',
                    component: SettingCashMovementRoutes
                },
                {
                    name: 'headboards',
                    path: '/headboards',
                    component: AddressRoutes
                },
                /*{
                  name: 'stock',
                  path: '/stock',
                  component: StockRoutes
                },*/
                {
                    name: 'taxes',
                    path: '/taxes',
                    component: Taxes
                },
                {
                    name: 'discountcodes',
                    path: '/discountcodes',
                    component: DiscountCodesIndex
                },
                {
                    name: 'destinations',
                    path: '/destinations',
                    component: Destinations
                },
                /*{
                  name: 'resources',
                  path: '/resources',
                  component: Resources
                },*/
                /*{
                  name: 'categories',
                  path: '/categories',
                  component: Categories
                },*/
                /*{
                  name: 'tags',
                  path: '/tags',
                  component: Tags
                },*/
            ]
        },
        {
            name: 'reports',
            links: [
                {
                    name: 'dashboard',
                    path: '/dashboardticket',
                    component: DashboardTicket
                },
                /*{
                  name: 'carts',
                  path: '/carts',
                  component: CartsRoutes
                },*/
                {
                    name: 'calendar',
                    path: '/calendar',
                    component: ReportsRoutes
                }, {
                    name: 'generalSales',
                    path: '/generalSales',
                    component: ReportsRoutes
                }, {
                    name: 'operatorGeneralSales',
                    path: '/operatorGeneralSales',
                    component: ReportsRoutes
                } /*,{
                  name: 'collaboratorTickets',
                  path: '/collaboratorTickets',
                  component: ReportsRoutes
                }*/ /*,{
                  name: 'operatorTickets',
                  path: '/operatorTickets',
                  component: ReportsRoutes
                }*/ /*,{
                  name: 'packets',
                  path: '/packetsales',
                  component: ReportsRoutes
                }*/,
                {
                    name: 'articleTickets',
                    path: '/sales',
                    component: ReportsRoutes
                },
                {
                    name: 'vouchers',
                    path: '/vouchers',
                    component: Voucher
                },
                {
                    name: 'cashDeskClosures',
                    path: '/ticketCashDesk',
                    component: ReportsRoutes
                },
                /*{
                  name: 'discountTickets',
                  path: '/ticketDescuento',
                  component: ReportsRoutes
                },*/
                {
                    name: 'canceledTickets',
                    path: '/ticketCanceled',
                    component: ReportsRoutes
                },
                {
                    name: 'usedGauges',
                    path: '/usedGauges',
                    component: UsedGaugesRoutes
                },
            ]
        },
        helpSections(isCivitrip)
    ]
        .filter(function (section) { return section.name; })
        .map(function (section) { return (__assign(__assign({}, section), { links: section.links.filter(function (link) { return link; }) })); });
};



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Main.tsx
// module id = 138
// module chunks = 0